export const ID_CONDITION_INSPECTION = "ID Condition Inspection";
